// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".terms .terms__header h2{margin-bottom:0}", "",{"version":3,"sources":["webpack://./src/modules/terms/modals/PolicyModal.vue"],"names":[],"mappings":"AAuBA,yBACE,eAAA","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.terms .terms__header h2\n  margin-bottom: 0\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
